import type { ReactElement } from 'react';
import { Button } from '@vwpfs/mary-air-lib/components/air/05-atoms/Button';
import { TextArea } from '@vwpfs/mary-air-lib/components/air/05-atoms/TextArea';
import { ThemePalette } from '@vwpfs/mary-air-lib/theme/_Types';

interface Props {
  reason: string;
  onReasonChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
  confirmLabel?: string;
  confirmDisabled?: boolean;
}

const sectionLabelStyle = {
  fontSize: '0.875rem',
  fontWeight: 600,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.05em',
  color: '#555',
  margin: 0
};

export function ModalReasonFooter({
  reason,
  onReasonChange,
  onCancel,
  onConfirm,
  isSubmitting,
  confirmLabel = 'Confirm',
  confirmDisabled = false
}: Props): ReactElement {
  return (
    <>
      <h4 style={sectionLabelStyle}>
        Reason <span style={{ color: '#888', fontWeight: 400 }}>(optional)</span>
      </h4>
      <div style={{ marginTop: '0.5rem' }}>
        <TextArea
          value={reason}
          onChange={(v: string | undefined) => onReasonChange(v ?? '')}
          placeholder="Why is this change needed?"
        />
      </div>

      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          justifyContent: 'flex-end',
          marginTop: '1.5rem',
          paddingTop: '1rem',
          borderTop: '1px solid #e5e5e5'
        }}
      >
        <Button
          buttonType="button"
          theme={{ palette: ThemePalette.CONTRAST_TERTIARY }}
          link={{ onClick: onCancel }}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button
          buttonType="button"
          theme={{ palette: ThemePalette.BRAND_PRIMARY }}
          link={{ onClick: onConfirm }}
          disabled={confirmDisabled || isSubmitting}
        >
          {isSubmitting ? 'Saving…' : confirmLabel}
        </Button>
      </div>
    </>
  );
}
